<!--
 * @Author: jjchen
 * @Date: 2022-08-10 14:27:53
 * @LastEditors: lz
 * @LastEditTime: 2022-10-10 14:44:52
 * @Description: 基础报告页
-->
<template>
  <div class="enterpriseHighNewH5Report">
    <div class="pageTop">
      <div class="companyName">{{ reportContent.companyName }}</div>
      <div class="reportTitle">国家高新技术企业认定报告</div>
      <van-button type="info" class="declare" @click="show = true"
        >申报咨询</van-button
      >
      <div class="changeAccount" @click="addInfo">
        <svg-icon icon-class="change" class="change"></svg-icon>
        <span>补充信息测评更精确</span>
      </div>
    </div>
    <declareConsult
      :show.sync="show"
      :companyName="companyName"
      @changeMask="changeMask"
    />
    <div class="companyInfo">
      <div class="leftInfo"></div>
      <div
        :class="reportContent.comprehensive < 10 ? 'numStyle' : 'num'"
        v-if="reportContent.comprehensive !== '100'"
      >
        {{ reportContent.comprehensive }}
      </div>
      <div class="specialNum" v-else>{{ reportContent.comprehensive }}</div>
      <div class="numText">综合指数</div>
      <div class="rightInfo">
        <div class="compName">{{ reportContent.companyName }}</div>
        <div class="compInfo createTime">
          成立时间：{{ reportContent.fromTime }}
        </div>
        <div class="compInfo">行业类型：{{ reportContent.industry }}</div>
        <img src="@/assets/images/gx-right.png" alt="" />
      </div>
    </div>
    <div class="figure">
      <img src="@/assets/images/gx-top.png" alt="" />
      <div class="figureTitle">综合能力图</div>
      <div class="line"></div>
      <div class="canvasDao">
        <radarMap :radarData="abilityScore" class="canvas" />
      </div>
    </div>
    <div class="table">
      <div class="tableHead">
        <div class="columnOne column">能力名称</div>
        <div class="columnTwo column">预估指数</div>
        <div class="column">测评说明（仅供参考）</div>
      </div>
      <div class="tableBody">
        <div class="content" v-for="(item, index) in abilityInfo" :key="index">
          <div class="abilityName columnOne">
            <span>{{ item.name }}</span>
          </div>
          <div class="index columnTwo">
            <span>{{ item.score }}</span>
          </div>
          <div class="desc">
            <span v-html="item.description">{{ item.description }}</span>
          </div>
        </div>
        <div class="mask" v-if="isAdvisory">
          <van-button type="info" class="plan" @click="show = true"
            >立即获取全部方案</van-button
          >
        </div>
      </div>
    </div>
    <!-- 返回小程序 -->
    <!-- <van-button
      v-if="!isWxEnv"
      type="info"
      class="back"
      @click="goback"
      >返回</van-button
    > -->
    <div v-if="isWxEnv" class="back">
      <div class="back-wrap" @click="goback">
        <span>返回</span>
        <img src="@/assets/images/H5/back.png" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>
<script>
import radarMap from "./components/radarMap.vue";
import declareConsult from "./components/declareConsult.vue";
import { getViewReportApi, checkAdvisoryApi } from "@/api/enterpriseHighNewH5";
export default {
  components: {
    radarMap,
    declareConsult,
  },
  data() {
    return {
      show: false,
      companyName: "",
      reportContent: {},
      abilityInfo: [],
      abilityScore: [],
      isAdvisory: false, //是否留咨
      reportId: "",
      isWxEnv: false, // 是否在微信小程序打开
    };
  },
  created() {
    if (this.$route.query.userId) {
      let userInfo = {
        userId: this.$route.query.userId,
        username: this.$route.query.username,
        orgId: this.$route.query.orgId,
        orgName: this.$route.query.orgName,
      };
      if (this.$route.query.applets) {
        userInfo.applets = this.$route.query.applets;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  },
  mounted() {
    if (this.$route.query.reportId) {
      this.reportId = this.$route.query.reportId;
    }
    this.getViewReport();
    this.checkAdvisory();
    //调用
    this.isWx().then((type) => {
      // this.$notify({
      //   type: "warning",
      //   message: type,
      // });
      this.isWxEnv = type == "mini-wx";
    });
  },
  methods: {
    //函数
    isWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return new Promise((resolve) => {
          this.$wx.miniProgram.getEnv(function(res) {
            if (res.miniprogram) {
              resolve("mini-wx");
            } else {
              resolve("wx");
            }
          });
        });
      } else {
        console.log("不在微信里");
        return new Promise((resolve) => {
          resolve("no-wx");
        });
      }
    },
    goback() {
      console.log(this.$wx.miniProgram);
      this.$wx.miniProgram.navigateTo({
        url: "/pages/index/index",
      });
    },
    addInfo() {
      this.$router.push({
        name: "enterpriseHighNewH5Evaluation",
        params: {
          companyName: this.reportContent.companyName,
          fromTime: this.reportContent.fromTime,
        },
      });
    },
    // 留咨后去掉遮挡
    changeMask() {
      this.isAdvisory = false;
    },
    async getViewReport() {
      const res = await getViewReportApi({
        reportId: this.reportId,
      });
      if (res.code == 0) {
        this.reportContent = res.data.reportContent;
        this.companyName = this.reportContent.companyName;
        this.abilityInfo.push(
          this.reportContent.intellectual,
          this.reportContent.science,
          this.reportContent.growUp,
          this.reportContent.research
        );
        this.abilityInfo.forEach((item) => {
          this.abilityScore.push(item.score);
        });
      } else {
        if (process && process.env.VUE_APP_MODE === "test") {
          location.href = `https://mtest.gongsibao.com/web/login.html?url=https://policytest.gongsibao.com/enterpriseHighNewH5/basicReport?reportId=${this.reportId}`;
        } else if (process && process.env.VUE_APP_MODE === "prod") {
          location.href = `https://m.gongsibao.com/web/login.html?url=https://policy.gongsibao.com/enterpriseHighNewH5/basicReport?reportId=${this.reportId}`;
        }
      }
    },
    async checkAdvisory() {
      const res = await checkAdvisoryApi();
      if (res.code == 0) {
        if (res.data.isAdvisory) {
          this.isAdvisory = false;
        } else {
          this.isAdvisory = true;
        }
      } else {
        this.isAdvisory = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.enterpriseHighNewH5Report {
  .pageTop {
    width: 7.5rem;
    height: 4.17rem;
    background-image: url("~@/assets/images/gxbg-report.png");
    background-size: 7.5rem 4.17rem;
    padding-top: 0.44rem;
    margin: 0 auto;
    position: relative;
    .companyName {
      font-size: 0.24rem;
      color: #ffffff;
      margin-left: 0.3rem;
    }
    .reportTitle {
      font-size: 0.52rem;
      color: #ffffff;
      letter-spacing: 0.01rem;
      display: flex;
      justify-content: center;
      margin-top: 0.33rem;
    }
    .declare {
      width: 2.7rem;
      height: 0.7rem;
      background: linear-gradient(310deg, #62aaff 0%, #3371ff 100%);
      border-radius: 4px;
      font-size: 0.26rem;
      font-weight: 500;
      margin: 0.3rem auto 0.49rem auto;
      display: flex;
      justify-content: center;
    }
    .changeAccount {
      width: 100%;
      height: 0.76rem;
      background: rgba(255, 255, 255, 0.17);
      text-align: center;
      color: #ffffff;
      font-size: 0.24rem;
      line-height: 0.76rem;
      cursor: pointer;
      position: absolute;
      bottom: 0;
      .change {
        margin-right: 0.1rem;
      }
    }
  }
  .companyInfo {
    width: 7.1rem;
    height: 2.59rem;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    display: flex;
    position: relative;
    margin: 0.52rem auto 0 auto;
    .leftInfo {
      width: 2.4rem;
      height: 100%;
      background: linear-gradient(315deg, #79aaff 0%, #4471ff 100%);
      opacity: 0.14;
      text-align: center;
    }
    .num {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 0.78rem;
    }
    .numStyle {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 1rem;
    }
    .specialNum {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 0.58rem;
    }
    .numText {
      font-size: 0.24rem;
      color: #4471ff;
      position: absolute;
      top: 1.5rem;
      left: 0.72rem;
    }
    .rightInfo {
      width: 4.69rem;
      border: 1px solid rgba(0, 114, 247, 0.07);
      border-left: none;
      padding: 0.3rem 0 0.3rem 0.23rem;
      position: relative;
      .compName {
        width: 4.16rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 0.26rem;
        font-weight: 500;
      }
      .createTime {
        margin-top: 0.2rem;
        margin-bottom: 0.15rem;
      }
      .compInfo {
        font-size: 0.24rem;
        color: #666666;
      }
      img {
        width: 0.79rem;
        height: 1.02rem;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .figure {
    width: 7.1rem;
    height: 6.41rem;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    border: 1px solid rgba(0, 114, 247, 0.07);
    margin: 0.2rem auto 0 auto;
    position: relative;
    img {
      height: 0.9rem;
    }
    .figureTitle {
      font-size: 0.28rem;
      color: #356eff;
      position: absolute;
      top: 0.7rem;
      left: 2.85rem;
    }
    .line {
      width: 1.4rem;
      height: 0.04rem;
      background: linear-gradient(
        270deg,
        rgba(121, 170, 255, 0) 0%,
        #4471ff 100%
      );
      margin: 0.25rem auto 0 auto;
    }
    .canvasDao {
      width: 7.1rem;
      height: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // .canvas {
    //   position: absolute;
    //   top: -1rem;
    //   right: -47%;
    //   // left: 50%;
    //   // transform: translate(-50%, 0);
    // }
  }
  .table {
    width: 7.1rem;
    margin: 0.2rem auto 0 auto;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    font-size: 0.24rem;
    padding-bottom: 0.21rem;
    .columnOne {
      width: 2.42rem;
    }
    .columnTwo {
      width: 1.37rem;
    }
    .tableHead {
      height: 0.7rem;
      background: #eef2ff;
      border-radius: 4px 4px 0px 0px;
      line-height: 0.7rem;
      display: flex;
      .column {
        padding-left: 0.2rem;
      }
    }
    .tableBody {
      position: relative;
      .mask {
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #f6f9ff 0%, #ffffff 100%);
        opacity: 0.97;
        border-radius: 4px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        .plan {
          width: 4.9rem;
          height: 0.7rem;
          background: linear-gradient(310deg, #62aaff 0%, #3371ff 100%);
          border-radius: 4px;
          font-size: 0.28rem;
          font-weight: 500;
        }
      }
      .content {
        // height: 3.85rem;
        border: 1px solid #edf5fe;
        border-top: none;
        min-height: 2.92rem;
        display: flex;
        align-items: center;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 2.42rem;
          width: 1px;
          height: 100%;
          background: #edf5fe;
        }
        &::after {
          content: "";
          position: absolute;
          left: 3.79rem;
          width: 1px;
          height: 100%;
          background: #edf5fe;
        }
        .abilityName {
          height: 100%;
          padding-left: 0.2rem;
        }
        .index {
          height: 100%;
          color: #ff6d33;
          text-align: center;
        }
        .desc {
          width: 2.9rem;
          // height: 3.24rem;
          margin: 0.2rem;
        }
      }
    }
  }
  .back {
    position: sticky;
    left: 1.93rem;
    bottom: 0.59rem;
    z-index: 999;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .back-wrap {
      height: 100%;
      width: 3.6rem;
      height: 0.64rem;
      background: #edf1fd;
      box-shadow: 0px 0.02rem 0.06rem 0.04rem rgba(221, 230, 255, 1);
      border-radius: 0.38rem;
      border: 1px solid #385eef;
      font-size: 0.34rem;
      font-weight: 500;
      color: #5370ff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-right: 0.28rem;
      }
      img {
        width: 0.39rem;
        height: 0.38rem;
      }
    }
  }
}
</style>
